import styled from '../../utils/styling/styled';

export const VisuallyHiddenSpan = styled.span`
  height: 1px;
  overflow: hidden;
  position: absolute;
  top: -10px;
  width: 1px;
`;
